import * as S from './styles';
import ButtonToTop from '../button-to-top/ButtonToTop';
import { useEffect, useState } from 'react';

interface FloatButtonToTopProps {
  elementId: string;
  bottom?: number;
  onPress?: () => void;
  className?: string;
  enabledScroll?: boolean;
}

const FloatButtonToTop = ({ onPress, elementId, bottom, className, enabledScroll }: FloatButtonToTopProps) => {
  const [rootWidth, setRootWidth] = useState(0);

  useEffect(() => {
    const root = document.getElementById(elementId);
    if (root) {
      setRootWidth(root.offsetWidth);
    }
  }, []);

  return (
    <S.FloatButton
      className={className}
      style={{ left: `calc(50% + ${rootWidth / 2}px)` }}
      $bottom={enabledScroll ? 65 : (bottom ?? 10)}
    >
      <ButtonToTop onPress={onPress} />
    </S.FloatButton>
  );
};

export default FloatButtonToTop;
